import React, { useState, useEffect } from "react";
import { Phone, MessageCircle, Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { CartIcon } from "@/components/shop/CartIcon";
function MobileMenuConsumer({
  onClose
}: {
  onClose: () => void;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="2753" className="flex flex-col gap-4 p-6">
        <div className="h-8 w-3/4 bg-muted animate-pulse rounded-md" />
        <div className="h-8 w-1/2 bg-muted animate-pulse rounded-md" />
        <div className="h-8 w-2/3 bg-muted animate-pulse rounded-md" />
      </div>;
  }
  return <nav className="flex flex-col p-6 gap-4">
      {menuItems.map(item => <Link key={item.id} to={item.href || "#"} className="text-lg font-medium text-foreground hover:text-primary transition-colors py-2 border-b border-border/50" onClick={onClose}>
          {item.label}
        </Link>)}
    </nav>;
}
export default function CabecalhoPrincipal() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
            setIsMobileMenuOpen(false);
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <section id="cabeçalho-volither" className="relative font-sans dark bg-background text-foreground">
      {}
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(100%); }
          100% { transform: translateX(-100%); }
        }
        .animate-marquee {
          animation: marquee 25s linear infinite;
        }
        
        .animate-marquee:hover {
          animation-play-state: paused;
        }
      `}</style>

      {}
      

      {}
      <header className={`sticky top-0 z-40 w-full transition-all duration-300 border-b border-transparent ${isScrolled ? "bg-background/80 backdrop-blur-xl shadow-lg border-border/50 py-2" : "bg-background py-4"}`}>
        <div className="container mx-auto px-4 flex items-center justify-between">
          {}
          <div className="flex items-center gap-4">
            <Link to="/" className="shrink-0">
              <img src="https://enjoyed-bug.10web.cloud/wp-content/uploads/2026/03/Logo_volither_dark.png" alt="Volither Logo" className="h-8 md:h-10 w-auto object-contain brightness-0 invert" />
            </Link>
          </div>

          {}
          <div className="hidden md:flex items-center gap-6">
            <div className="flex items-center gap-4 ![margin:0px_32px_0px_0px]">
              <Link to="/#sobre" className="text-sm font-medium transition-colors ![padding:8px_16px_8px_16px] hover:text-primary">Sobre</Link>
              <Link to="/#tecnologia" className="text-sm font-medium transition-colors ![padding:8px_16px_8px_16px] hover:text-primary">Tecnologia</Link>
              <Link to="/#setores" className="text-sm font-medium transition-colors ![padding:8px_16px_8px_16px] hover:text-primary">Setores</Link>
            </div>
            <div className="flex items-center gap-4">
              <Link to="/#contato">
                <Button className="bg-primary hover:bg-primary/90 text-primary-foreground font-bold uppercase tracking-tighter shadow-xl hover:shadow-primary/20 transition-all transform hover:-translate-y-0.5 text-sm px-6 py-5 h-auto rounded-lg">
                  Agendar demonstração
                </Button>
              </Link>
            </div>
          </div>

          {}
          <div className="flex items-center gap-3 md:hidden">
           {/*<CartIcon variant="ghost" size="icon" className="text-foreground" />*/}
            <Link to="/#contato">
              <Button size="sm" className="bg-primary hover:bg-primary/90 text-primary-foreground font-bold uppercase text-xs px-3 h-9">
                Agendar demonstração
              </Button>
            </Link>
            {/*<Button variant="ghost" size="icon" onClick={() => setIsMobileMenuOpen(true)} className="text-foreground hover:bg-accent transition-colors" aria-label="Abrir menu">
              <Menu className="h-6 w-6" />
             </Button>*/}
          </div>
        </div>
      </header>

      {}
      {isMobileMenuOpen && <div className="fixed inset-0 z-50 flex justify-end">
          {}
          <div className="absolute inset-0 bg-black/80 backdrop-blur-sm transition-opacity" onClick={() => setIsMobileMenuOpen(false)} />
          
          {}
          <div className="relative w-[80%] max-w-sm bg-card h-full shadow-2xl flex flex-col animate-in slide-in-from-right duration-300">
            <div className="flex items-center justify-between p-4 border-b border-border">
              <span className="font-bold text-lg text-foreground tracking-tight">MENU</span>
              <Button variant="ghost" size="icon" onClick={() => setIsMobileMenuOpen(false)} className="hover:bg-accent rounded-full transition-colors">
                <X className="h-5 w-5" />
              </Button>
            </div>

            <div className="flex-1 overflow-y-auto">
              <MenuProvider menu_id="22" className="w-full">
                <MobileMenuConsumer onClose={() => setIsMobileMenuOpen(false)} />
              </MenuProvider>
              
              <div className="p-6 border-t border-border mt-auto">
                <div className="flex flex-col gap-4">
                  <div className="flex items-center gap-3 text-muted-foreground">
                    <Phone className="h-4 w-4 text-primary" />
                    <span className="text-sm font-mono">0800 591 0352</span>
                  </div>
                  <Link to="/#contato" onClick={() => setIsMobileMenuOpen(false)}>
                    <Button className="w-full bg-primary hover:bg-primary/90 text-primary-foreground font-bold uppercase tracking-tighter">
                      Solicitar demonstração
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>}
    </section>;
}